import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import {formatPrice} from '../helpers/helpers'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';
import PurchaseOrderView from './PurchaseOrderView'
import JobOrderDownload from './JobOrderDownload'

class PurchaseOrderViewTab extends Component {

   constructor(){
        super();
        this.state = {
            userId : "",
            user : {},
            order : {},
            orderLm : {},
            orderSheets : {},
            job :{}
        }
        
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        }); 

         var dbEdit = ref.child("PurchaseOrder").child(this.props.match.params.oid);
                    dbEdit.on("value",function(data){             
                        this.setState({
                            order : data.val(),
                            orderLm : data.val().orderLm,
                            orderSheets : data.val().orderSheets                            
                        });

                    }.bind(this)); 

        var query = ref.child("JobOrder")
                    query.on("value",function(data){             
                        this.setState({
                            job : data.val()                            
                        });

                    }.bind(this));   

    }

    
    render() {
            
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar/>
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Order Details" />
                            <div className="block">
                                <div>                             
                                {/*<!-- Working Tabs Block -->*/}
                                <div className="block full">
                                    {/*<!-- Working Tabs Content -->*/}
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/*<!-- Block Tabs -->*/}
                                            <div >
                                                {/*<!-- Block Tabs Title -->*/}
                                                <div className="block-title no-print">
                                                    <ul className="nav nav-tabs" data-toggle="tabs">
                                                        <li className="active"><a href="#example-tabs2-activity">Order</a></li>
                                                        <li><a href="#example-tabs2-profile">JobOrder</a></li>
                                                        
                                                    </ul>
                                                </div>
                                                {/*<!-- END Block Tabs Title -->*/}

                                                {/*<!-- Tabs Content -->*/}
                                                <div className="tab-content ">
                                                    <div className="tab-pane active" id="example-tabs2-activity">
                                                        {/**********<!-- Order Details -->**********/}
                                                        <PurchaseOrderView order={this.state.order} orderLm={this.state.orderLm} orderSheets={this.state.orderSheets}/>
                                                        
                                                    </div>
                                                    <div className="tab-pane" id="example-tabs2-profile">
                                                        {/**********<!-- JOb Order -->**********/}
                                                        {

                                                            this.state.job &&                                     
                                                                Object.keys(this.state.job).map(function (key){
                                                                    let list = this.state.job[key]                                                                                                                             
                                                                        if(list.quoteNumber == this.state.order.quoteNumber){
                                                                            return <JobOrderDownload job={list} />                                                    
                                                                        }

                                                                }.bind(this))

                                                        }
                                                         
                                                    </div>
                                                </div>
                                                {/*<!-- END Tabs Content -->*/}
                                            </div>
                                            {/*<!-- END Block Tabs -->*/}
                                        </div>
                                    </div>
                                    {/*<!-- END Working Tabs Content -->*/}
                                </div>
                                {/*<!-- Working Tabs Block -->*/}
                             </div>
                            </div>                        
                        </div>
                       <Footer />
                     </div>
                </div>
            </div>
        );
    }
}

export default PurchaseOrderViewTab;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderViewTab.js